/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

import { useState } from 'react';

/**
 * Custom hook to manage report, render and processing state for one summary visual
 * Called by SummaryWidget so hiding a visual grid preserves its state.
 * @returns {Object} Report, render and processing state with their setters
 */
const useSummaryVisualState = () => {
  const [report, setReport] = useState({});
  const [isRendered, setIsRendered] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);
  return { report, setReport, isRendered, setIsRendered, isProcessing, setIsProcessing };
};

export default useSummaryVisualState;
